// Polyfills for SSR
var isSSR = typeof window === 'undefined';
var HTMLElement = isSSR ? Object : window.HTMLElement;
var File = isSSR ? Object : window.File;

export { File as F, HTMLElement as H };



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/chunk-b9bdb0e4.js
// module id = UZQh
// module chunks = 0 1